export default __webpack_public_path__ + "static/craig-2cd3be177bb3b27f7ec9b131194d27e2.jpeg";